// Animaciones de las escenas del puerto (maqueta aprobada por Vadik, 12-oct-2026).
// Todas son bucles sin cortes: lo que sale de la pantalla vuelve a entrar por fuera de la vista.
export const CSS_ESCENAS = `
.pe-bocadillo { opacity: 0; }
.pe-estela { animation: pe-estela 11s linear infinite; opacity: 0; }
@keyframes pe-estela { 0%, 22% { opacity: 0; transform: translateX(0); } 28% { opacity: .9; } 46% { opacity: 0; transform: translateX(-90px); } 100% { opacity: 0; transform: translateX(-90px); } }
.pe-ola-grande { animation: pe-olaGrande 11s ease-in-out infinite; opacity: 0; }
@keyframes pe-olaGrande { 0%, 26% { opacity: 0; transform: translateX(130px); } 31% { opacity: 1; } 46% { opacity: 0; transform: translateX(-160px); } 100% { opacity: 0; transform: translateX(-160px); } }
.pe-barquito { animation: pe-barquito 11s ease-in-out infinite; }
@keyframes pe-barquito {
  0%, 4% { transform: translate(0,0) rotate(0); }
  14% { transform: translate(-100px, 6px) rotate(0); }
  32% { transform: translate(-100px, 6px) rotate(0); }
  35% { transform: translate(-100px, -10px) rotate(-16deg); }
  39% { transform: translate(-96px, 10px) rotate(14deg); }
  43% { transform: translate(-102px, -7px) rotate(-11deg); }
  47% { transform: translate(-98px, 5px) rotate(7deg); }
  52% { transform: translate(-100px, 4px) rotate(-3deg); }
  56%, 84% { transform: translate(-100px, 6px) rotate(0); }
  97%, 100% { transform: translate(0,0) rotate(0); }
}
.pe-remo { animation: pe-remo .8s ease-in-out infinite alternate; transform-origin: 100% 0%; }
@keyframes pe-remo { from { transform: rotate(-12deg); } to { transform: rotate(14deg); } }
.pe-sombrero { animation: pe-sombrero 11s ease-in-out infinite; }
@keyframes pe-sombrero {
  0%, 34% { transform: translate(0,0) rotate(0); }
  39% { transform: translate(-22px,-36px) rotate(-200deg); }
  45% { transform: translate(-40px, 15px) rotate(-340deg); }
  52% { transform: translate(-41px, 18px) rotate(-350deg); }
  60% { transform: translate(-39px, 15px) rotate(-338deg); }
  68% { transform: translate(-41px, 18px) rotate(-350deg); }
  74% { transform: translate(-40px, 16px) rotate(-340deg); }
  80% { transform: translate(-18px, -24px) rotate(-250deg); }
  86%, 100% { transform: translate(0, 0) rotate(-360deg); }
}
.pe-b-paso { animation: pe-bPaso 11s infinite; }
@keyframes pe-bPaso { 0%, 1% { opacity: 0; } 3%, 14% { opacity: 1; } 16%, 100% { opacity: 0; } }
.pe-b-ay { animation: pe-bAy 11s infinite; }
@keyframes pe-bAy { 0%, 37% { opacity: 0; } 39%, 54% { opacity: 1; } 56%, 100% { opacity: 0; } }
.pe-b-recu { animation: pe-bRecu 11s infinite; }
@keyframes pe-bRecu { 0%, 85% { opacity: 0; } 87%, 97% { opacity: 1; } 99%, 100% { opacity: 0; } }
.pe-hucha { animation: pe-hucha 2.4s ease-in-out infinite; }
@keyframes pe-hucha { 0%,100% { transform: translateY(0) rotate(-4deg); } 50% { transform: translateY(3px) rotate(4deg); } }
.pe-moneda-vuela { animation: pe-monedaVuela 6s ease-in-out infinite; }
@keyframes pe-monedaVuela { 0% { opacity: 0; transform: translate(0,0); } 12%, 22% { opacity: 1; transform: translate(0,0); } 36% { transform: translate(22px,-34px); } 54% { opacity: 1; transform: translate(42px,48px); } 56%, 100% { opacity: 0; transform: translate(42px,48px); } }
.pe-lanza { animation: pe-lanza 6s ease-in-out infinite; transform-origin: 0% 0%; }
@keyframes pe-lanza { 0%, 4% { transform: rotate(60deg); } 12%, 22% { transform: rotate(0); } 28% { transform: rotate(-50deg); } 40%, 100% { transform: rotate(60deg); } }
.pe-clinc { animation: pe-clinc 6s ease-out infinite; opacity: 0; transform-origin: 50% 50%; }
@keyframes pe-clinc { 0%, 54% { opacity: 0; transform: scale(.3); } 57% { opacity: 1; } 70%, 100% { opacity: 0; transform: scale(1.6); } }
.pe-b-dia2 { animation: pe-bDia2 6s infinite; }
@keyframes pe-bDia2 { 0%, 1% { opacity: 0; } 3%, 26% { opacity: 1; } 28%, 100% { opacity: 0; } }
.pe-b-oink { animation: pe-bOink 6s infinite; }
@keyframes pe-bOink { 0%, 56% { opacity: 0; } 58%, 90% { opacity: 1; } 92%, 100% { opacity: 0; } }
.pe-alas-loro { animation: pe-alasLoro .35s steps(1) infinite; }
@keyframes pe-alasLoro { 50% { transform: translateY(-2px) scaleY(.5); } }
.pe-brillo { animation: pe-brillo 1.4s ease-in-out infinite; transform-origin: 50% 50%; }
@keyframes pe-brillo { 0%, 100% { opacity: 0; transform: scale(.4); } 50% { opacity: 1; transform: scale(1); } }
.pe-b-loro { animation: pe-bLoro 8s infinite; }
@keyframes pe-bLoro { 0%, 2% { opacity: 0; } 4%, 40% { opacity: 1; } 42%, 100% { opacity: 0; } }
.pe-b-pirata { animation: pe-bPirata 8s infinite; }
@keyframes pe-bPirata { 0%, 48% { opacity: 0; } 50%, 88% { opacity: 1; } 90%, 100% { opacity: 0; } }
.pe-cana2 { animation: pe-cana2 8s ease-in-out infinite; transform-origin: 0% 100%; }
@keyframes pe-cana2 { 0%, 34% { transform: rotate(0); } 42% { transform: rotate(-22deg); } 54%, 100% { transform: rotate(0); } }
.pe-bolsa { animation: pe-bolsa 8s ease-in-out infinite; }
@keyframes pe-bolsa {
  0%, 36% { opacity: 0; transform: translate(0,0); }
  38% { opacity: 1; transform: translate(0,0); }
  50%, 62% { transform: translate(-40px,-56px); }
  66% { transform: translate(-78px,-56px); }
  74% { transform: translate(-50px,-96px); }
  84% { opacity: 1; transform: translate(-6px,14px); }
  90%, 100% { opacity: 0; transform: translate(-6px,24px); }
}
.pe-b-ganga { animation: pe-bGanga 8s infinite; }
@keyframes pe-bGanga { 0%, 50% { opacity: 0; } 52%, 63% { opacity: 1; } 65%, 100% { opacity: 0; } }
.pe-b-nopres { animation: pe-bNopres 8s infinite; }
@keyframes pe-bNopres { 0%, 65% { opacity: 0; } 67%, 94% { opacity: 1; } 96%, 100% { opacity: 0; } }
.pe-aleta { animation: pe-aleta 10s linear infinite; }
.pe-aleta.b { animation-duration: 13s; animation-delay: -6s; animation-direction: reverse; }
@keyframes pe-aleta { from { transform: translateX(-70px); } to { transform: translateX(430px); } }
.pe-aleta-sube { animation: pe-aletaSube 1.6s ease-in-out infinite; }
@keyframes pe-aletaSube { 50% { transform: translateY(2px); } }
.pe-bote { animation: pe-hucha 2.8s ease-in-out infinite; }
.pe-b-com1 { animation: pe-bCom1 12s infinite; }
@keyframes pe-bCom1 { 0%, 14% { opacity: 0; } 16%, 42% { opacity: 1; } 44%, 100% { opacity: 0; } }
.pe-b-com2 { animation: pe-bCom2 12s infinite; }
@keyframes pe-bCom2 { 0%, 62% { opacity: 0; } 64%, 90% { opacity: 1; } 92%, 100% { opacity: 0; } }
.pe-haz { animation: pe-haz 8s ease-in-out infinite; transform-origin: 0% 41.9%; }
@keyframes pe-haz { 0%, 100% { transform: rotate(-25deg); } 35%, 62% { transform: rotate(27deg); } }
.pe-sigilo { animation: pe-sigilo 8s ease-in-out infinite; }
@keyframes pe-sigilo { 0%, 100% { transform: translateX(0); } 30% { transform: translateX(18px); } 36%, 62% { transform: translateX(18px) translateY(-2px); } 70% { transform: translateX(10px); } }
.pe-b-faro { animation: pe-bFaro 8s infinite; }
@keyframes pe-bFaro { 0%, 35% { opacity: 0; } 37%, 62% { opacity: 1; } 64%, 100% { opacity: 0; } }
.pe-b-oferta { animation: pe-bOferta 8s infinite; }
@keyframes pe-bOferta { 0%, 41% { opacity: 0; } 43%, 64% { opacity: 1; } 66%, 100% { opacity: 0; } }
.pe-salta { animation: pe-salta .5s ease-in-out infinite alternate; }
@keyframes pe-salta { to { transform: translateY(-6px); } }
.pe-bombilla { animation: pe-bombilla 1s steps(1) infinite; }
@keyframes pe-bombilla { 50% { opacity: .25; } }
.pe-nota-m { animation: pe-notaM 3s linear infinite; opacity: 0; }
@keyframes pe-notaM { 0% { opacity: 0; transform: translate(0,0); } 15% { opacity: 1; } 100% { opacity: 0; transform: translate(14px,-60px); } }
.pe-teclea { animation: pe-teclea .3s steps(1) infinite; }
@keyframes pe-teclea { 50% { transform: translateY(1px); } }
.pe-b-calc { animation: pe-bCalc 8s infinite; }
@keyframes pe-bCalc { 0%, 28% { opacity: 0; } 30%, 72% { opacity: 1; } 74%, 100% { opacity: 0; } }
.pe-cae { animation: pe-cae 12s linear infinite; }
@keyframes pe-cae { 0% { transform: translate(230px,-70px); } 24% { transform: translate(230px,130px); } 28% { transform: translate(230px,140px); } 62% { transform: translate(230px,282px); } 66% { transform: translate(234px,282px); } 100% { transform: translate(430px,282px); } }
.pe-tumba { animation: pe-tumba 12s linear infinite; transform-origin: 50% 50%; }
@keyframes pe-tumba { 0% { transform: rotate(0); } 24% { transform: rotate(720deg); } 26%, 100% { transform: rotate(720deg); } }
.pe-abre { animation: pe-abre 12s ease-out infinite; transform-origin: 50% 100%; }
@keyframes pe-abre { 0%, 24% { transform: scale(0); opacity: 0; } 25% { opacity: 1; } 30% { transform: scale(1); } 62% { transform: scale(1); } 68%, 100% { transform: scale(.35, .12) translateX(-60px); opacity: 1; } }
.pe-balanceo { animation: pe-vaiven 2.4s ease-in-out infinite; transform-origin: 50% 0%; }
@keyframes pe-vaiven { 0%,100% { transform: rotate(-6deg); } 50% { transform: rotate(6deg); } }
.pe-b-lavadora { animation: pe-bLavadora 12s infinite; }
@keyframes pe-bLavadora { 0%, 4% { opacity: 0; } 6%, 23% { opacity: 1; } 25%, 100% { opacity: 0; } }
.pe-b-ahorre { animation: pe-bAhorre 12s infinite; }
@keyframes pe-bAhorre { 0%, 64% { opacity: 0; } 66%, 84% { opacity: 1; } 86%, 100% { opacity: 0; } }
.pe-mira { animation: pe-mira 2.6s steps(1) infinite; }
@keyframes pe-mira { 0% { transform: translateX(-1.5px); } 50% { transform: translateX(1.5px); } }
.pe-botella { animation: pe-botella 16s linear infinite; }
@keyframes pe-botella { from { transform: translateX(-60px); } to { transform: translateX(420px); } }
.pe-cabecea { animation: pe-cabecea 1.8s ease-in-out infinite; transform-origin: 50% 50%; }
@keyframes pe-cabecea { 0%,100% { transform: translateY(0) rotate(-14deg); } 50% { transform: translateY(3px) rotate(10deg); } }
.pe-b-sos { animation: pe-bSos 16s infinite; }
@keyframes pe-bSos { 0%, 28% { opacity: 0; } 32%, 62% { opacity: 1; } 66%, 100% { opacity: 0; } }
.pe-gaviota-l { animation: pe-gaviotaL 10s ease-in-out infinite; }
@keyframes pe-gaviotaL {
  0%, 18% { transform: translate(260px, -90px); opacity: 1; }
  38% { transform: translate(0, 0); }
  42% { transform: translate(-4px, 2px); }
  62% { transform: translate(-280px, -110px); opacity: 1; }
  62.2% { transform: translate(-280px, -110px); opacity: 0; }
  62.4% { transform: translate(260px, -90px); opacity: 0; }
  62.6%, 100% { transform: translate(260px, -90px); opacity: 1; }
}
.pe-aleteo { animation: pe-aleteo .3s steps(1) infinite; }
@keyframes pe-aleteo { 50% { transform: scaleY(-.6); } }
.pe-moneda-robada { animation: pe-monedaRobada 10s linear infinite; }
@keyframes pe-monedaRobada { 0%, 39% { opacity: 0; } 40%, 62% { opacity: 1; } 62.2%, 100% { opacity: 0; } }
.pe-moneda-pila { animation: pe-monedaPila 10s linear infinite; }
@keyframes pe-monedaPila { 0%, 39% { opacity: 1; transform: translateY(0); } 40%, 82% { opacity: 0; transform: translateY(-8px); } 88%, 100% { opacity: 1; transform: translateY(0); } }
.pe-mano { animation: pe-mano 10s ease-in-out infinite; transform-origin: 0% 0%; }
@keyframes pe-mano { 0%, 78% { transform: rotate(0); } 83% { transform: rotate(-40deg); } 88%, 100% { transform: rotate(0); } }
.pe-b-eh { animation: pe-bEh 10s infinite; }
@keyframes pe-bEh { 0%, 41% { opacity: 0; } 43%, 64% { opacity: 1; } 66%, 100% { opacity: 0; } }
.pe-velero { animation: pe-velero 11s linear infinite; }
@keyframes pe-velero { 0%, 18% { transform: translateX(-60px); } 46%, 100% { transform: translateX(430px); } }
.pe-escena * { transform-box: fill-box; }
@media (prefers-reduced-motion: reduce) { .pe-escena { display: none; } }
`;
